import { grondGebruiken, fosfaatSoorten, grondSoorten, onbekendId } from './grond-gebruiken';
import { isTotalsCalculated } from './totalen';
import { verdelingGrondsoorten, gewaspercelen, filteredVerdelingGrondsoorten } from './percelen-model';
import { auth } from './auth';

export const atoms = {
  grondGebruiken,
  fosfaatSoorten,
  auth,
  grondSoorten,
  onbekendId,
  verdelingGrondsoorten,
  gewaspercelen,
  filteredVerdelingGrondsoorten,
  isTotalsCalculated,
};
